export class AppRoutes {
  // --- Base Segments ---
  static readonly APP: string = 'app';
  static readonly AUTH: string = 'auth';
  static readonly LOGIN: string = 'login';
  static readonly FORCE_CHANGE_PASSWORD: string = 'force-change-password';
  static readonly HOME: string = 'home';
  static readonly DETAILS: string = 'details';
  static readonly PROFILE: string = 'profile';
  static readonly DESKTOP: string = 'desktop';
  static readonly SAVE: string = 'save';
  static readonly SAVE_WITH_UUID: string = ':uuid/save';
  static readonly DETAILS_WITH_UUID: string = ':uuid/details';

  // --- Auth Routes ---
  static readonly LOGIN_ROUTE = `/${this.AUTH}/${this.LOGIN}`;
  static readonly FORCE_CHANGE_PASSWORD_ROUTE = `/${this.AUTH}/${this.FORCE_CHANGE_PASSWORD}`;

  // --- Main / Dashboard ---
  static readonly HOME_ROUTE = `/${this.APP}/${this.HOME}`;

  // --- Utilisateurs ---
  static readonly USERS: string = 'users';
  static readonly USERS_LIST_ROUTE: string = `/${this.APP}/${this.USERS}`;

  // --- Passages ---
  static readonly PASSAGES: string = 'passages';
  static readonly PASSAGES_LIST_ROUTE: string = `/${this.APP}/${this.PASSAGES}`;

  // --- Abonnés ---
  static readonly TOLL_SUBSCRIBERS: string = 'toll-subscribers';
  static readonly TOLL_SUBSCRIBERS_LIST_ROUTE: string = `/${this.APP}/${this.TOLL_SUBSCRIBERS}`;
  static getTollSubscriberDetailsRoute(uuid: string): string {
    return `/${this.APP}/${this.TOLL_SUBSCRIBERS}/${uuid}/${this.DETAILS}`;
  }

  // --- Abonnements ---
  static readonly SUBSCRIPTIONS: string = 'subscriptions';
  static readonly SUBSCRIPTIONS_LIST_ROUTE: string = `/${this.APP}/${this.SUBSCRIPTIONS}`;

  // --- Paiements ---
  static readonly PAYMENTS: string = 'payments';
  static readonly PAYMENTS_LIST_ROUTE: string = `/${this.APP}/${this.PAYMENTS}`;

  // --- Sites ---
  static readonly SITES: string = 'sites';
  static readonly SITES_LIST_ROUTE: string = `/${this.APP}/${this.SITES}`;

  // --- Types de véhicules ---
  static readonly VEHICLE_TYPES: string = 'vehicle-types';
  static readonly VEHICLE_TYPES_LIST_ROUTE: string = `/${this.APP}/${this.VEHICLE_TYPES}`;

  // --- Tarifs ---
  static readonly TARIFFS: string = 'tariffs';
  static readonly TARIFS_NON_ABONNEMENTS: string = 'tarifs-non-abonnements';
  static readonly TARIFFS_LIST_ROUTE: string = `/${this.APP}/${this.TARIFFS}`;
  static readonly TARIFS_NON_ABONNEMENT_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.TARIFS_NON_ABONNEMENTS}`;

  // --- Reporting Consolidé (Nouveautés) ---
  static readonly REPORTING: string = 'reporting';
  static readonly GLOBAL_REPORTS: string = 'global';
  static readonly SESSION_REPORTS: string = 'sessions';

  // Route utilisée par le routerLink de la Sidebar
  static readonly REPORTING_ROUTE: string = `/${this.APP}/${this.REPORTING}`;
  static readonly GLOBAL_REPORT_ROUTE: string = `/${this.APP}/${this.REPORTING}/${this.GLOBAL_REPORTS}`;
  static readonly SESSION_REPORT_ROUTE: string = `/${this.APP}/${this.REPORTING}/${this.SESSION_REPORTS}`;

  // --- Desktop / Administrateurs ---
  static readonly ADMINISTRATEURS: string = 'administrateurs';
  static readonly ADMIN_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.ADMINISTRATEURS}`;

  // --- Agents ---
  static readonly AGENT: string = 'agents';
  static readonly AGENT_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.AGENT}`;

  // --- Ames ---
  static readonly AMES: string = 'ames';
  static readonly AMES_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.AMES}`;

  // --- Cabines ---
  static readonly CABINE: string = 'cabines';
  static readonly CABINE_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.CABINE}`;

  // --- Caissiers ---
  static readonly CAISSIER: string = 'caissiers';
  static readonly CAISSIER_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.CAISSIER}`;

  // --- Controles ---
  static readonly CONTROLE: string = 'controles';
  static readonly CONTROLE_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.CONTROLE}`;

  // --- Manquants ---
  static readonly MANQUANT: string = 'manquants';
  static readonly MANQUANT_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.MANQUANT}`;

  // --- Rapports Archives ---
  static readonly RAPPORTS: string = 'reports';
  static readonly REPORTS_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.RAPPORTS}`;
  static readonly REPORT_OVERVIEW_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.RAPPORTS}`;

  // --- Recettes ---
  static readonly RECETTE: string = 'recettes';
  static readonly RECETTE_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.RECETTE}`;

  // --- Receveurs ---
  static readonly RECEVEUR: string = 'receveurs';
  static readonly RECEVEUR_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.RECEVEUR}`;

  // --- Redditions ---
  static readonly REDDITION: string = 'redditions';
  static readonly REDDITION_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.REDDITION}`;

  // --- Responsables ---
  static readonly RESPONSABLE: string = 'responsables';
  static readonly RESPONSABLE_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.RESPONSABLE}`;

  // --- Supervisions ---
  static readonly SUPERVISION: string = 'supervisions';
  static readonly SUPERVISION_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.SUPERVISION}`;

  // --- Surveillants ---
  static readonly SURVEILLANT: string = 'surveillants';
  static readonly SURVEILLANT_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.SURVEILLANT}`;

  // --- Vacations ---
  static readonly VACATION: string = 'vacations';
  static readonly VACATION_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.VACATION}`;

  // --- Historique ---
  static readonly HISTORIQUE: string = 'histories';
  static readonly HISTORIQUE_LIST_ROUTE: string = `/${this.APP}/${this.DESKTOP}/${this.HISTORIQUE}`;

  // --- Profil ---
  static readonly PROFILE_ROUTE: string = `/${this.APP}/${this.PROFILE}`;
}
